<div [matMenuTriggerFor]="notificationMenu" #menuTrigger="matMenuTrigger"></div>
<mat-menu #notificationMenu="matMenu" xPosition="before" class="notification-menu">
  <div class="container-notfications">
    <!-- Header Section -->
    <div class="notification-header-section">
      <h4 class="notification-title">
        <a>Notifications</a>
      </h4>
      <div class="checkbox-container" (click)="$event.stopPropagation()">
        <input type="checkbox" id="showUnread" [checked]="checked" (change)="onInputChange($event)"
          class="unread-checkbox">
          <label for="showUnread" class="checkbox-label">Show Unread</label>
        </div>
      </div>

      <hr class="line" />

      <!-- Tabs -->
      <div class="notification-tabs" (click)="$event.stopPropagation()">
        <div class="notification-tab" [class.active-tab]="activeTab === 'personal'" (click)="switchTab('personal')">
          All
        </div>
        <div class="notification-tab" [class.active-tab]="activeTab === 'configuration'" (click)="switchTab('configuration')">
          Configuration Setting
        </div>
        <div class="notification-tab" [class.active-tab]="activeTab === 'systemNotification'" (click)="switchTab('systemNotification')">
          System Notification
        </div>
        <div class="notification-tab" [class.active-tab]="activeTab === 'duplications'" (click)="switchTab('duplications')">
          Duplications
        </div>
      </div>

      <!-- Notification Content -->
      <div class="notification-content" *ngIf="activeTab === 'personal'">
        @if (notificationsError || (notifications | json) == '{}') {
          <div class="empty-notifications">
            <i class="fas fa-bell fa-5x empty-notification-icon"></i>
            <div class="empty-notification-text">
              No new notifications
            </div>
          </div>
        }

        @if (!notificationsError && (notifications | json) != '{}') {
          <div class="notifications-container">
            <div infinite-scroll [infiniteScrollDistance]="distance" [infiniteScrollThrottle]="throttle"
              (scrolled)="onScroll()">
              @for (notification of notifications | keyvalue : orderOriginal; track notification) {
                <div class="notification-group">
                  @for (item of notification.value; track item; let i = $index) {
                    <div>
              <div class="notification-card" [ngClass]="{
                'read-notification': item.is_read,
                'unread-notification': !item.is_read
              }"
                        (mouseover)="hoverActive = true; itemIndex = i; itemKey = notification.key"
                        (mouseout)="hoverActive = false; itemIndex = -1; itemKey = ''"
                        [ngStyle]="hoverActive && i === itemIndex && itemKey == notification.key && {'background-color': 'rgb(221, 226, 231)' }"
                        (click)="handleNotificationClick($event, item)">
                        <div class="notification-content-wrapper">
                          <div class="notification-details">
                            <div class="title-time-row">
                              <div class="title-section">
                                @if (!item.is_read) {
                                  <div class="unread-dot" matTooltip="Unread"></div>
                                }
                                <div class="notification-title-text">
                                  {{ item.title }}
                                </div>
                                @if (item.created_datetime || item.created_date || item.timestamp) {
                                  <div class="notification-time"
                                    >
                                    {{ getFormattedTime(item.created_datetime || item.created_date || item.timestamp) }}
                                  </div>
                                }
                              </div>
                            </div>
                            <div class="message-section">
                              @if (!item.url) {
                                <div class="notification-message" (click)="handle_no_url($event)">
                                  {{ item.message }}
                                </div>
                              }
                              @if (item.url) {
                                <div class="notification-message">
                                  <a
                                    href="javascript:void(0)"
                                    (click)="handleNotificationLinkClick($event, item)"
                                    >
                                    {{ item.message }}
                                  </a>
                                </div>
                              }
                            </div>
                          </div>
                          <div class="sender-avatar">
                            <div
                              class="avatar"
                              [matTooltip]="getNotificationAvatarName(item)"
    [ngClass]="{
      'font-italic': getNotificationAvatarName(item) === 'System Notification',
      'font-weight-normal': getNotificationAvatarName(item) !== 'System Notification'
    }">
                              {{ printInitial(getNotificationAvatarName(item)) }}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  }
                </div>
              }
            </div>
          </div>
        }
      </div>

      <!-- Duplications Content (duplicate-question detection from the nightly scan) -->
      <div class="notification-content" *ngIf="activeTab === 'duplications'">
        @if (duplicationNotificationsError || !duplicationNotifications || (duplicationNotifications | json) == '{}') {
          <div class="empty-notifications">
            <i class="fas fa-clone fa-5x empty-notification-icon"></i>
            <div class="empty-notification-text">
              No duplicate question alerts
            </div>
          </div>
        }

        @if (!duplicationNotificationsError && duplicationNotifications && (duplicationNotifications | json) != '{}') {
          <div class="notifications-container">
            @for (notification of duplicationNotifications | keyvalue : orderOriginal; track notification) {
              <div class="notification-group">
                @for (item of notification.value; track item; let i = $index) {
                  <div>
                    <div class="duplication-card" [ngClass]="{
                      'read-notification': item.is_read,
                      'unread-notification': !item.is_read
                    }">
                      <div class="duplication-icon-badge">
                        <i class="fas fa-clone"></i>
                      </div>
                      <div class="duplication-details">
                        <div class="title-time-row">
                          <div class="notification-title-text">
                            {{ item.title }}
                          </div>
                          @if (!item.is_read) {
                            <div class="unread-dot" matTooltip="Unread"></div>
                          }
                        </div>
                        <div class="notification-message">
                          {{ item.message }}
                        </div>
                        <div class="duplication-footer">
                          @if (item.created_datetime || item.created_date || item.timestamp) {
                            <div class="notification-time">
                              {{ getFormattedTime(item.created_datetime || item.created_date || item.timestamp) }}
                            </div>
                          }
                          <a href="javascript:void(0)" class="view-details-link"
                            (click)="handleDuplicationViewDetails($event, item)">
                            View Details <i class="fas fa-chevron-right"></i>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                }
              </div>
            }
          </div>
        }
      </div>

      <!-- Configuration Setting Content (placeholder - not wired up yet) -->
      <div class="notification-content" *ngIf="activeTab === 'configuration'">
        <div class="empty-notifications">
          <i class="fas fa-bell fa-5x empty-notification-icon"></i>
          <div class="empty-notification-text">
            No configuration notifications
          </div>
        </div>
      </div>

      <!-- System Notification Content (placeholder - not wired up yet) -->
      <div class="notification-content" *ngIf="activeTab === 'systemNotification'">
        <div class="empty-notifications">
          <i class="fas fa-bell fa-5x empty-notification-icon"></i>
          <div class="empty-notification-text">
            No system notifications
          </div>
        </div>
      </div>

      <!-- Bottom Actions -->
      <div class="notification-actions">
        <div class="mark-read-btn" (click)="markAllAsRead($event)">
          Mark all as read
        </div>

        <button class="view-all-btn" [routerLink]="['/notifications']" 
          (click)="closeMenuAndNavigate($event)">
          <span class="btn-text">View All</span>
        </button>
      </div>
    </div>
  </mat-menu>
